import { render, staticRenderFns } from "./ActionsSelector.vue?vue&type=template&id=4c5fc6c6&scoped=true&"
import script from "./ActionsSelector.vue?vue&type=script&lang=js&"
export * from "./ActionsSelector.vue?vue&type=script&lang=js&"
import style0 from "./ActionsSelector.vue?vue&type=style&index=0&id=4c5fc6c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5fc6c6",
  null
  
)

/* custom blocks */
import block0 from "./ActionsSelector.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports